import { Pipe, PipeTransform } from "@angular/core";
import { BetTicketStatus } from "@enum/ticket-status.enum";
import { normalizeBetTicketStatus } from "@function/normalize-ticket-status.function";

@Pipe({
  name: "ticketStatus",
  pure: false,
})
export class TicketStatusPipe implements PipeTransform {
  transform(
    rawStatus: string | null | undefined,
    fallback?: BetTicketStatus
  ): BetTicketStatus {
    const statusText = rawStatus.toString().trim().toLowerCase()
    const normalized = normalizeBetTicketStatus(statusText);
    
    if(normalized) {
      return normalized
    }
    return fallback;
  }
}
